/**
 * File accettati come allegato documentale di un ingrediente
 * (`POST /ingredient-documents/upload`): PDF per schede tecniche e
 * certificati, immagini per la foto dell'etichetta del fornitore letta da
 * "Completa con IA" (DEV-375), conservata come prova della fonte. Il backend
 * verifica i magic bytes, non il Content-Type del client.
 */
export const INGREDIENT_DOCUMENT_UPLOAD_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

export type IngredientDocumentUploadMimeType =
  (typeof INGREDIENT_DOCUMENT_UPLOAD_MIME_TYPES)[number];

export function isIngredientDocumentUploadMimeType(
  mimeType: string,
): mimeType is IngredientDocumentUploadMimeType {
  return (INGREDIENT_DOCUMENT_UPLOAD_MIME_TYPES as readonly string[]).includes(mimeType);
}
